<modal-panel title="Filter Traveler Payments" (close)="close()">
  <div class="filter" [formGroup]="form">
    <div class="filter__fields" [class.two-col]="!isSmall">

      <mat-form-field>
        <mat-label>Trip Reference</mat-label>
        <input matInput formControlName="TripReference" placeholder="e.g. ABCDEF"/>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Traveler Name</mat-label>
        <input matInput formControlName="TravelerName" placeholder="e.g. Smith"/>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Product Type</mat-label>
        <input matInput formControlName="ProductTypeName" placeholder="e.g. Hotel"/>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Payment Date From</mat-label>
        <input matInput readonly [matDatepicker]="payFrom" formControlName="PaymentDateFrom"/>
        <mat-hint>MM/DD/YYYY</mat-hint>
        <mat-datepicker #payFrom/>
        <mat-datepicker-toggle matIconSuffix [for]="payFrom"/>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Payment Date To</mat-label>
        <input matInput readonly [matDatepicker]="payTo" formControlName="PaymentDateTo"/>
        <mat-hint>MM/DD/YYYY</mat-hint>
        <mat-datepicker #payTo/>
        <mat-datepicker-toggle matIconSuffix [for]="payTo"/>
      </mat-form-field>

    </div>
  </div>
  <ng-container modalPanelFooter>
    <button mat-button (click)="reset()">Reset</button>
    <button mat-raised-button color="primary" (click)="apply()">Apply</button>
  </ng-container>
</modal-panel>
